export const benefitsHero = {
  title: '受講特典',
  titleEn: 'BENEFITS',
  lead: '各コースには、執事の実務ですぐに役立つ特典をご用意しています。',
};

export const courseBenefits = [
  {
    id: 'essential',
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    lead: '執事としての第一歩を支える、基本の道具と装備をお渡しします。学びのその日から、実務を意識した環境で研鑽を積んでいただけます。',
    imageAlt: 'オリジナルエプロンと執事道具セット',
    imageCaption: '基本道具セットとオリジナルエプロン',
    items: [
      {
        name: '基本道具セット',
        description: 'プロ仕様の基本的な執事道具一式。コース修了後も実務でご活用いただけます。',
        icon: 'ri-tools-line',
      },
      {
        name: '教科書セット（全5冊・E1〜E5）',
        description: '協会監修の教科書5冊。「執事学入門」から「英国紳士の教養とたしなみ」まで、執事の基礎を体系的に学べるセットです。',
        icon: 'ri-book-open-line',
      },
      {
        name: 'オリジナルエプロン',
        description: 'アカデミー特製の実習用エプロン。上質な素材で、所作を妨げない設計です。',
        icon: 'ri-shirt-line',
      },
      {
        name: '白手袋',
        description: '高品質な白手袋。執事の象徴として、初日からサービス実習で着用します。',
        icon: 'ri-hand-sanitizer-line',
      },
    ],
  },
  {
    id: 'advanced',
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    lead: 'エッセンシャルコースの特典に加え、より専門的な道具と知識を深める教材をお渡しします。',
    imageAlt: 'ワインオープナーセット',
    imageCaption: 'ワインオープナーセット',
    items: [
      {
        name: '基本道具セット',
        description: 'プロ仕様の基本的な執事道具一式。',
        icon: 'ri-tools-line',
        inherited: true,
      },
      {
        name: '教科書セット（計10冊・E1〜E5+A1〜A5）',
        description: 'エッセンシャルのE群5冊に加え、家政管理・秘書業務・テーブルマナー・イベント企画・ライフスタイル管理のA群5冊。全日本執事協会監修。',
        icon: 'ri-book-open-line',
      },
      {
        name: 'オリジナルエプロン',
        description: 'アカデミー特製の実習用エプロン。',
        icon: 'ri-shirt-line',
        inherited: true,
      },
      {
        name: 'ワインオープナーセット',
        description: 'プロ仕様のワインオープナーと付属ツールのセット。ソムリエ級のサービスに対応します。',
        icon: 'ri-goblet-line',
      },
      {
        name: '白手袋',
        description: '高品質な白手袋。執事の象徴として着用します。',
        icon: 'ri-hand-sanitizer-line',
        inherited: true,
      },
    ],
  },
  {
    id: 'master',
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    lead: 'アドバンスコースの特典に加え、プロフェッショナルとしての格を形にする、特別な装備品をお渡しします。',
    imageAlt: 'オーダーメイドベストと高級懐中時計のクローズアップ',
    imageCaption: 'オーダーメイドベストと高級懐中時計',
    items: [
      {
        name: '基本道具セット',
        description: 'プロ仕様の基本的な執事道具一式。',
        icon: 'ri-tools-line',
        inherited: true,
      },
      {
        name: '全教科書セット（全15冊・E1〜E5+A1〜A5+M1〜M5）',
        description: 'E群・A群に加え、国際プロトコル・危機管理・VVIPサービスなどM群5冊を含む全15冊。執事学の基礎から最上級のマネジメントまで網羅。',
        icon: 'ri-book-open-line',
      },
      {
        name: 'オリジナルエプロン',
        description: 'アカデミー特製の実習用エプロン。',
        icon: 'ri-shirt-line',
        inherited: true,
      },
      {
        name: 'ワインオープナーセット',
        description: 'プロ仕様のワインオープナーと付属ツールのセット。',
        icon: 'ri-goblet-line',
        inherited: true,
      },
      {
        name: 'オーダーメイドベスト',
        description: '受講生お一人おひとりに合わせて仕立てる、アカデミー特製のベスト。採寸からお渡しまで丁寧にご用意します。',
        icon: 'ri-vip-crown-line',
      },
      {
        name: '高級懐中時計',
        description: '執事の品格を象徴する高品質な懐中時計。所作の美しさを引き立てる逸品です。',
        icon: 'ri-time-line',
      },
      {
        name: '白手袋',
        description: '高品質な白手袋。執事の象徴として着用します。',
        icon: 'ri-hand-sanitizer-line',
        inherited: true,
      },
    ],
  },
];

export const commonBenefits = {
  title: '全コース共通の特典',
  titleEn: 'COMMON BENEFITS',
  lead: 'コースを問わず、すべての受講生の皆様に共通してご用意している特典です。学びの成果を形にし、修了後の道を支えます。',
  items: [
    {
      name: '修了証',
      description: '所定のカリキュラムを修了された方に、日本執事アカデミー修了証を授与します。',
      icon: 'ri-award-line',
    },
    {
      name: '協会認定資格・認定ピンバッジ',
      description: '修了実技試験に合格された方に、全日本執事協会が認定する資格（認定アソシエイト／プロフェッショナル／マスターバトラー）と認定ピンバッジを授与します。当協会独自の民間資格です。',
      icon: 'ri-medal-line',
    },
    {
      name: '修了生向けキャリア支援（準備中）',
      description: '修了生の方へ、全日本執事協会が把握する執事関連の求人情報を提供する仕組みを予定しています。キャリア形成の選択肢のひとつとしてご活用いただけるよう準備を進めています。',
      icon: 'ri-briefcase-line',
    },
  ],
};

export const whiteGlovesInfo = {
  title: '白手袋について',
  titleEn: 'WHITE GLOVES',
  lead: '白手袋は、全コースで初日から支給し、実習中は常時着用していただきます。執事の所作を象徴する装備であり、清潔さ・品格・専門性を体現するものです。実習を通じて、手袋を着けたままの繊細な動作を身につけていただきます。',
  imageAlt: '白手袋を着用した執事の所作',
};

export const benefitsNotes = [
  '特典内容はコースにより異なります。上記の一覧で、ご自身の受講されるコースの特典をご確認ください。',
  '特典の金銭的価値（○円相当などの表示）は記載しておりません。いずれも実務での実用価値を重視して選定した品々です。',
  '特典内容は予告なく変更する場合があります。最新の情報は、資料請求または個別相談にてご確認ください。',
];

export const benefitsFaqs = [
  {
    question: '特典は何がもらえますか?',
    answer: 'コースに応じて執事道具セット、教科書、エプロン、白手袋などをご用意しています。上位コースではオーダーメイドベストや全教科書セットなども含まれます。',
  },
  {
    question: '特典は実務で使えますか?',
    answer: 'はい。記念品ではなく、実際の執事業務で使える実用品を選んでいます。',
  },
  {
    question: '認定資格ももらえますか?',
    answer: '各コース修了時の実技試験に合格すると、協会認定資格と認定ピンバッジを授与します（当協会独自の民間資格です）。',
  },
];

export const benefitsRelatedPages = [
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: '料金概要',
    description: '受講料と含まれるもの',
    href: '/pricing',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: 'コース別料金詳細',
    description: 'コースごとの料金内訳',
    href: '/pricing/details',
  },
];